import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import Moment from "moment";
import DataTable from "react-data-table-component";
import { countryList } from "../../components/Conteries";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import {
  getsuperAdminDashboardUserDetails,
  getsuperAdminQrCodeAndScanSttWallet,
  getsuperAdminSalesDetail,
  getCountryWiseSalesDetail,
  getsuperAdminQrcodecountrywiseDetail,
  getsuperAdminScancountrywiseDetail,
  getsuperAdminQrcodeSavedcountrywiseDetail,
  getsuperAdminUserPackageBycountryDetails,
  getsuperAdmincountryIDbyUserDetails,
} from "../../api/apiSuperadmin";
import { NumericFormat } from "react-number-format";

const Superdashboard = (props) => {
  let history = useHistory();
  const [packagemodal, setpackagemodal] = useState(false);
  const [customizedUsersdetail, setcustomizedUsersdetail] = useState(false);
  const [superCountrywisesalesdetail, setsuperCountrywisesalesdetail] =
    useState(false);

  //UserDetails
  // const [selectStartDate, setselectStartDate] = useState(
  //   Moment(new Date()).subtract("days", 30)
  // );
  const [selectStartDate, setselectStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  // const [selectEndDate, setselectEndDate] = useState(
  //   Moment(new Date()).add("days", 30)
  // );
  const [selectEndDate, setselectEndDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );

  //SalesDetails
  const [selectSalesStartDate, setselectSalesStartDate] = useState(
    // Moment(new Date()).subtract("days", 30)
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [selectSalesEndDate, setselectSalesEndDate] = useState(
    //Moment(new Date()).add("days", 30)
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );

  //QrcodeDetails
  const [selectQrcodeStartDate, setselectQrcodeStartDate] = useState(
    // Moment(new Date()).subtract("days", 30)
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [selectQrcodrEndDate, setselectQrcodrEndDate] = useState(
    //Moment(new Date()).add("days", 30)
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );

  const [Isloading, setIsloading] = useState(false);

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      return () => {
        history.push("/Login");
      };
    } else {
      SuperAdminDashboardUserDetails(selectStartDate, selectEndDate);
      SuperAdminSalesDetail(selectSalesStartDate, selectSalesEndDate);
      SuperAdminQrCodeAndScanSttWallet(
        selectQrcodeStartDate,
        selectQrcodrEndDate
      );
    }
  }, []);

  // superAdmin============================
  const [
    superCountrywisesalesdetailishow,
    setsuperCountrywisesalesdetailishow,
  ] = useState(false);
  const [maincountryuserlistshow, setmaincountryuserlistshow] = useState(false);
  const [superadmincountryuserlistshow, setsuperadmincountryuserlistshow] =
    useState(false);
  const [selectcountrywisescan, setselectcountrywisescan] = useState("");
  const [selectcustomized, setselectcustomized] = useState(false);

  const [superadminqrscansttlistshow, setsuperadminqrscansttlistshow] =
    useState(false);

  const [superadmQrcodeCountryshow, setsuperadmQrcodeCountryshow] =
    useState(false);
  const [superadminsavedshow, setsuperadminsavedshow] = useState(false);

  const [superadminqrscanstt, setsuperadminqrscanstt] = useState();

  const [DashboardUserDetails, setDashboardUserDetails] = useState(null);

  const [DashboardSalesDetails, setDashboardSalesDetails] = useState(null);

  const [DashboardScanSttWalletDetails, setDashboardScanSttWalletDetails] =
    useState(null);
  const [IsShowallSalesDetails, setIsShowallSalesDetails] = useState(false);

  const [IsShowallQrcodeDetails, setIsShowallQrcodeDetails] = useState(false);

  const [DashboardQrocodeCountryDetails, setDashboardQrocodeCountryDetails] =
    useState([]);

  const [DashboardScanCountryDetails, setDashboardScanCountryDetails] =
    useState([]);

  const [DashboardSavedCountryDetails, setDashboardSavedCountryDetails] =
    useState([]);

  const [countryuserlist, setcountryuserlist] = useState([]);
  const [superCountrywiselist, setsuperCountrywiselist] = useState([]);
  const [packagDetailslist, setpackagDetailslist] = useState([]);
  // superAdmin============================

  const toggleuserdetail = async (items) => {
    let SDate = Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EDate = Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
    const response = await getsuperAdmincountryIDbyUserDetails(
      items?.packageID,
      items?.countryID,
      SDate,
      EDate
    );
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setcustomizedUsersdetail(true);
      setcountryuserlist(response);
    } else {
      setcustomizedUsersdetail(true);
      setcountryuserlist([]);
    }
  };
  const toggleuserdetailclose = () => {
    setcustomizedUsersdetail(false);
  };
  const togglesuperCountrywisesalesdetail = async () => {
    let SDate = Moment(selectSalesStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EDate = Moment(selectSalesEndDate).format("YYYY/MM/DD") + " 00:00:00";
    const response = await getCountryWiseSalesDetail(SDate, EDate);
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setsuperCountrywisesalesdetail(true);
      setsuperCountrywiselist(response);
    } else {
      setsuperCountrywisesalesdetail(true);
      setsuperCountrywiselist([]);
    }
  };
  const showalltogglesuperCountrywisesalesdetail = async () => {
    const response = await getCountryWiseSalesDetail("", "");
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setsuperCountrywisesalesdetail(true);
      setsuperCountrywiselist(response);
    } else {
      setsuperCountrywisesalesdetail(true);
      setsuperCountrywiselist([]);
    }
  };

  const togglesuperCountrywisesalesdetailclosed = () => {
    setsuperCountrywisesalesdetail(false);
  };
  const togglesetsuperadminqrscanstt = () => {
    setsuperadminqrscanstt(!superadminqrscanstt);
  };

  const packagetoggle = async (packageID) => {
    let SDate = Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EDate = Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";

    const response = await getsuperAdminUserPackageBycountryDetails(
      packageID,
      SDate,
      EDate
    );
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setpackagemodal(true);
      setpackagDetailslist(response);
    } else {
      setpackagemodal(true);
      setpackagDetailslist([]);
    }
  };

  const packagetoggleclose = () => {
    setpackagemodal(false);
  };
  const dateRange = {
    currentWeek:
      Moment(selectStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("D / MM / YYYY"),
  };
  const SalesdateRange = {
    currentWeek:
      Moment(selectSalesStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectSalesEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectSalesStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectSalesEndDate).format("D / MM / YYYY"),
  };
  const QrcodedateRange = {
    currentWeek:
      Moment(selectQrcodeStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectQrcodrEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectQrcodeStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectQrcodrEndDate).format("D / MM / YYYY"),
  };

  const userhandleDateApplyEvent = (event, picker) => {
    setselectEndDate(Moment(new Date(picker.endDate)));
    setselectStartDate(Moment(new Date(picker.startDate)));
    let startdate = Moment(new Date(picker.startDate));
    let Enddate = Moment(new Date(picker.endDate));
    SuperAdminDashboardUserDetails(startdate, Enddate);
  };
  const SaelshandleDateApplyEvent = (event, picker) => {
    setselectSalesEndDate(Moment(new Date(picker.endDate)));
    setselectSalesStartDate(Moment(new Date(picker.startDate)));
    let startdate = Moment(new Date(picker.startDate));
    let Enddate = Moment(new Date(picker.endDate));
    SuperAdminSalesDetail(startdate, Enddate);
  };
  const QrcodehandleDateApplyEvent = (event, picker) => {
    setselectQrcodrEndDate(Moment(new Date(picker.endDate)));
    setselectQrcodeStartDate(Moment(new Date(picker.startDate)));
    let startdate = Moment(new Date(picker.startDate));
    let Enddate = Moment(new Date(picker.endDate));
    SuperAdminQrCodeAndScanSttWallet(startdate, Enddate);
  };

  // superadmin

  const customizedwisecolumn = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row?.sr}`,
        sortable: false,
        cell: (row, index) => row?.sr,
      },
      {
        name: "Country",
        accessor: "packageCountryName",
        selector: "packageCountryName",
        sortable: false,
        cell: (row) => {
          return (
            <div className="widget-list-media icon">
              <div className="widget-list-content  pb-1 pt-1 border-none">
                <h5 className="widget-list-title">
                  {row?.packageCountryName ? row?.packageCountryName : "N/A"}
                </h5>
              </div>
            </div>
          );
        },
      },
      {
        name: "Package",
        accessor: "packageName",
        selector: "packageName",
        sortable: false,
        cell: (row) => {
          return (
            <div className="widget-list-media icon">
              <div className="widget-list-content  pb-1 pt-1 border-none">
                <h5 className="widget-list-title">
                  {row?.packageName ? row?.packageName : "N/A"}
                </h5>
              </div>
            </div>
          );
        },
      },

      {
        name: "Users",
        accessor: "categoryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return row?.totalUser != null &&
              row?.totalUser != "" &&
              row?.totalUser > 0 ? (
              <>
                <div className="widget-list-media icon">
                  <div className="widget-list-content  pb-1 pt-1 border-none">
                    <h5 className="widget-list-title">
                      {row?.totalUser ? row?.totalUser : "N/A"}
                    </h5>
                  </div>
                </div>
                <button
                  onClick={(e) => {
                    toggleuserdetail(row);
                  }}
                  type="button"
                  className="btn btn-primary btn-xs ml-3"
                >
                  Details
                </button>
              </>
            ) : (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.totalUser ? row?.totalUser : "0"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Value",
        accessor: "totalPriceValue",
        selector: (row) => `${row?.totalPriceValue ? row?.totalPriceValue : 0}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const columnsuserdetails = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row?.sr}`,
        sortable: false,
        cell: (row, index) => row?.sr,
      },
      {
        name: "Country",
        accessor: "countryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.countryName ? row?.countryName : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Users Email",
        accessor: "userEmail",
        selector: "userEmail",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.userEmail ? row?.userEmail : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Start date",
        accessor: "startDate",
        selector: "startDate",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.startDate
                      ? Moment(row?.startDate).format("DD / MM / YYYY")
                      : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "End date",
        accessor: "endDate",
        selector: "endDate",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.endDate
                      ? Moment(row?.endDate).format("DD / MM / YYYY")
                      : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Value",
        accessor: "value",
        selector: (row) => `${row?.price}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const columnsuperCountrywiselist = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row?.sr}`,
        sortable: false,
        cell: (row, index) => row?.sr,
      },
      {
        name: "Country",
        accessor: "countryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.countryName ? row?.countryName : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Sale",
        accessor: "salevalue",
        selector: (row) => `${row?.totalSale ? row?.totalSale : "0"}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const columnsuperadmQrcodeCountry = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row.sr}`,
        sortable: false,
        cell: (row, index) => row.sr,
      },
      {
        name: "Country",
        accessor: "countryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.qrCodesCountryName ? row?.qrCodesCountryName : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Qr Codes",
        accessor: "totalQrCodes",
        selector: (row) => `${row.totalQrCodes}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const columnsuperadmSavedCountry = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row.sr}`,
        sortable: false,
        cell: (row, index) => row.sr,
      },
      {
        name: "Country",
        accessor: "countryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.walletCountry ? row?.walletCountry : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "STT wallet saving",
        accessor: "totalQrCodes",
        selector: (row) => `${row.totalwallet}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const columnsuperadmScanCountry = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "8%",
        accessor: "sr",
        selector: (row) => `${row.sr}`,
        sortable: false,
        cell: (row, index) => row.sr,
      },
      {
        name: "Country",
        accessor: "countryName",
        selector: "name",
        sortable: false,
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <div className="widget-list-content  pb-1 pt-1 border-none">
                  <h5 className="widget-list-title">
                    {row?.scansCountryName ? row?.scansCountryName : "N/A"}
                  </h5>
                </div>
              </div>
            );
          }
        },
      },
      {
        name: "Scans",
        accessor: "totalQrCodes",
        selector: (row) => `${row.totalScans}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  const SuperAdminDashboardUserDetails = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminDashboardUserDetails(SDate, EDate);
      if (response) {
        setDashboardUserDetails(response);
      } else {
        setDashboardUserDetails(null);
      }
    }
  };
  const SuperAdminQrCodeAndScanSttWallet = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      setIsShowallQrcodeDetails(false);
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminQrCodeAndScanSttWallet(SDate, EDate);
      if (response) {
        setDashboardScanSttWalletDetails(response);
      } else {
        setDashboardScanSttWalletDetails(null);
      }
    }
  };
  const SuperAdminSalesDetail = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      setIsShowallSalesDetails(false);
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminSalesDetail(SDate, EDate);
      if (response) {
        setDashboardSalesDetails(response);
      } else {
        setDashboardSalesDetails(null);
      }
    }
  };

  const ShowallSuperAdminSalesDetail = async () => {
    setIsShowallSalesDetails(true);
    const response = await getsuperAdminSalesDetail("", "");
    if (response) {
      setDashboardSalesDetails(response);
    } else {
      setDashboardSalesDetails(null);
    }
  };

  const ShowSuperAdminQrCodeAndScanSttWallet = async () => {
    setIsShowallQrcodeDetails(true);
    const response = await getsuperAdminQrCodeAndScanSttWallet("", "");
    if (response) {
      setDashboardScanSttWalletDetails(response);
    } else {
      setDashboardScanSttWalletDetails(null);
    }
  };
  // qrcode country
  const ShowAllSuperAdminQrCodeCountryDetails = async () => {
    const response = await getsuperAdminQrcodecountrywiseDetail("", "");
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setDashboardQrocodeCountryDetails(response);
    } else {
      setDashboardQrocodeCountryDetails([]);
    }
  };
  const SuperAdminQrCodeCountryDetails = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminQrcodecountrywiseDetail(SDate, EDate);
      if (response) {
        response?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setDashboardQrocodeCountryDetails(response);
      } else {
        setDashboardScanSttWalletDetails([]);
      }
    }
  };

  //scan country

  const ShowAllSuperAdminScanCountryDetails = async () => {
    const response = await getsuperAdminScancountrywiseDetail("", "");
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setDashboardScanCountryDetails(response);
    } else {
      setDashboardScanCountryDetails([]);
    }
  };
  const SuperAdminScanCountryDetails = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminScancountrywiseDetail(SDate, EDate);
      if (response) {
        response?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setDashboardScanCountryDetails(response);
      } else {
        setDashboardScanCountryDetails([]);
      }
    }
  };

  //Saved country

  const ShowAllSuperAdminSavedCountryDetails = async () => {
    const response = await getsuperAdminQrcodeSavedcountrywiseDetail("", "");
    if (response) {
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setDashboardSavedCountryDetails(response);
    } else {
      setDashboardSavedCountryDetails([]);
    }
  };
  const SuperAdminSavedCountryDetails = async (startDateObj, endDateObj) => {
    if (
      startDateObj !== null &&
      startDateObj !== "" &&
      startDateObj !== undefined &&
      endDateObj !== null &&
      endDateObj !== undefined &&
      endDateObj !== ""
    ) {
      let SDate = Moment(startDateObj).format("YYYY/MM/DD") + " 00:00:00";
      let EDate = Moment(endDateObj).format("YYYY/MM/DD") + " 00:00:00";
      const response = await getsuperAdminQrcodeSavedcountrywiseDetail(
        SDate,
        EDate
      );
      if (response) {
        response?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setDashboardSavedCountryDetails(response);
      } else {
        setDashboardSavedCountryDetails([]);
      }
    }
  };

  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item active">Home</li>
      </ol>
      <h1 className="page-header mb-3">Dashboard</h1>

      {/*=========================================== SuperAdmin =========================================== */}
      <div className="row change-header-bg">
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">User detail</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div
                // className="d-sm-flex align-items-center mb-3">
                className="row align-items-center mb-3"
              >
                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  <DateRangePicker
                    startDate={selectStartDate}
                    endDate={selectEndDate}
                    onApply={userhandleDateApplyEvent}
                    dateFormat="DD/MM/YYYY"
                  >
                    <button className="btn btn-success text-truncate w-100">
                      <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
                      <span>{dateRange.currentWeek}</span>
                      <b className="caret"></b>
                    </button>
                  </DateRangePicker>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  <p className="mb-0 text-white">
                    Total Users{" "}
                    <b>
                      {DashboardUserDetails?.totalUser
                        ? DashboardUserDetails?.totalUser
                        : "0"}
                    </b>
                  </p>
                </div>
              </div>
              <div className="table-responsive">
                <table
                  className="table table-bordered m-b-0"
                  style={{ color: "#FFFFFF" }}
                >
                  <thead style={{ backgroundColor: "#959595" }}>
                    <tr className="text-center">
                      <th className="table-sr-scan-width">Sr #</th>
                      <th>Packages</th>
                      <th>OS</th>
                      <th>Yearly/Monthly</th>
                      <th className="table-scan-width">Active users</th>
                      <th className="table-scan-width">Detail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardUserDetails !== null &&
                    DashboardUserDetails !== undefined &&
                    DashboardUserDetails !== "" &&
                    DashboardUserDetails?.superAdminPackageslist?.length > 0 ? (
                      DashboardUserDetails?.superAdminPackageslist.map(
                        (item, i) => (
                          <tr className="text-center">
                            <td className="align-middle">{i + 1}</td>
                            <td className="align-middle">
                              {item?.packageName ? item?.packageName : "N/A"}
                            </td>
                            <td className="align-middle">
                              {item?.isWeb === false ? "Mobile" : "Web"}
                            </td>
                            <td className="align-middle">
                              {item?.isMonthly === false ? "Yearly" : "Monthly"}
                            </td>
                            <td className="align-middle">
                              {" "}
                              {item?.activeTotalUser
                                ? item?.activeTotalUser
                                : "0"}
                            </td>
                            <td className="align-middle">
                              <button
                                type="button"
                                className="btn btn-primary btn-xs ml-3"
                                onClick={(e) => {
                                  // if (item?.packagesname === "Customised") {
                                  //   setselectcustomized(true);
                                  // } else {
                                  //   setselectcustomized(false);
                                  // }
                                  packagetoggle(item?.packagesID);
                                }}
                              >
                                Details
                              </button>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <label>No Data Found</label>
                    )}
                  </tbody>
                </table>
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Sales</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="row align-items-center mb-3">
                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  <DateRangePicker
                    startDate={selectSalesStartDate}
                    endDate={selectSalesEndDate}
                    onApply={SaelshandleDateApplyEvent}
                    dateFormat="DD/MM/YYYY"
                  >
                    <button className="btn btn-success text-truncate w-100">
                      <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
                      <span>{SalesdateRange.currentWeek}</span>
                      <b className="caret"></b>
                    </button>
                  </DateRangePicker>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  {IsShowallSalesDetails === true ? (
                    <button
                      className="mb-0 "
                      onClick={(e) => {
                        setIsShowallSalesDetails(false);
                        SuperAdminSalesDetail(
                          selectSalesStartDate,
                          selectSalesEndDate
                        );
                      }}
                    >
                      Hide All
                    </button>
                  ) : (
                    <button
                      className="mb-0 "
                      onClick={(e) => {
                        ShowallSuperAdminSalesDetail();
                      }}
                    >
                      Show All
                    </button>
                  )}
                </div>
              </div>
              <div className="row pt-3">
                <div className="col-xl-6 col-lg-8 col-xs-12">
                  <div className="row align-items-center text-white">
                    <div className="col-md-4 col-xs-6">
                      <p className="mb-0">Total Sale</p>
                    </div>
                    <div className="col-md-6 col-xs-4">
                      <h2 className="text-white">
                        <NumericFormat
                          prefix={"£"}
                          displayType="text"
                          thousandSeparator={true}
                          className="text-right w-100my"
                          placeholder="0"
                          decimalScale={2}
                          fixedDecimalScale={false}
                          value={
                            DashboardSalesDetails?.totalSale
                              ? DashboardSalesDetails?.totalSale
                              : "£ 0"
                          }
                        />
                      </h2>
                    </div>
                  </div>
                  <div className="row align-items-center text-white">
                    <div className="col-md-4 col-xs-6">
                      <p className="mb-0">Included VAT</p>
                    </div>
                    <div className="col-md-6 col-xs-4">
                      <h2 className="text-white">
                        <NumericFormat
                          prefix={"£"}
                          displayType="text"
                          thousandSeparator={true}
                          className="text-right w-100my"
                          placeholder="0"
                          decimalScale={2}
                          fixedDecimalScale={false}
                          value={
                            DashboardSalesDetails?.totalIncludedVAT
                              ? DashboardSalesDetails?.totalIncludedVAT
                              : "£ 0"
                          }
                        />
                      </h2>
                    </div>
                  </div>
                  <div className="border"></div>
                  <div className="row align-items-center text-white my-2">
                    <div className="col-md-4 col-xs-6">
                      <p className="mb-0">Net Sale</p>
                    </div>
                    <div className="col-md-6 col-xs-4">
                      <h1 className="text-white">
                        <NumericFormat
                          prefix={"£"}
                          displayType="text"
                          thousandSeparator={true}
                          className="text-right w-100my"
                          placeholder="0"
                          decimalScale={2}
                          fixedDecimalScale={false}
                          value={
                            DashboardSalesDetails?.netSale
                              ? DashboardSalesDetails?.netSale
                              : "£ 0"
                          }
                        />
                      </h1>
                    </div>
                    <div className="col-md-2 col-xs-2">
                      {IsShowallSalesDetails === true ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={(e) => {
                            showalltogglesuperCountrywisesalesdetail();
                          }}
                        >
                          Detail
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={(e) => {
                            togglesuperCountrywisesalesdetail();
                          }}
                        >
                          Detail
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-12 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">QR Code and scan</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="row align-items-center mb-3">
                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  <DateRangePicker
                    startDate={selectQrcodeStartDate}
                    endDate={selectQrcodrEndDate}
                    onApply={QrcodehandleDateApplyEvent}
                    dateFormat="DD/MM/YYYY"
                  >
                    <button className="btn btn-success text-truncate w-100">
                      <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
                      <span>{QrcodedateRange.currentWeek}</span>
                      <b className="caret"></b>
                    </button>
                  </DateRangePicker>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-5  my-1">
                  {IsShowallQrcodeDetails === true ? (
                    <button
                      className="mb-0 "
                      onClick={(e) => {
                        SuperAdminQrCodeAndScanSttWallet(
                          selectQrcodeStartDate,
                          selectQrcodrEndDate
                        );
                      }}
                    >
                      Hide All
                    </button>
                  ) : (
                    <button
                      className="mb-0 "
                      onClick={(e) => {
                        ShowSuperAdminQrCodeAndScanSttWallet();
                      }}
                    >
                      Show All
                    </button>
                  )}
                </div>
              </div>
              <div className="row">
                <div class="col-lg-4 col-sm-6">
                  <div class="widget widget-stats bg-teal mb-7px">
                    <div class="stats-icon stats-icon-lg">
                      <i class="fa fa-qrcode fa-fw"></i>
                    </div>
                    <div class="stats-content">
                      <div class="stats-title">Qr Code generated</div>
                      <div class="stats-number">
                        {DashboardScanSttWalletDetails?.totalQrcode}
                      </div>
                      {IsShowallQrcodeDetails === true ? (
                        <button
                          onClick={async () => {
                            setselectcountrywisescan("qrcode");
                            await ShowAllSuperAdminQrCodeCountryDetails();
                            togglesetsuperadminqrscanstt();
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            setselectcountrywisescan("qrcode");
                            SuperAdminQrCodeCountryDetails(
                              selectQrcodeStartDate,
                              selectQrcodrEndDate
                            );
                            togglesetsuperadminqrscanstt();
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                  <div class="widget widget-stats bg-blue mb-7px">
                    <div class="stats-icon stats-icon-lg">
                      <i class="fa fa-qrcode fa-fw"></i>
                    </div>
                    <div class="stats-content">
                      <div class="stats-title">Scans</div>
                      <div class="stats-number">
                        {DashboardScanSttWalletDetails?.totalScans}
                      </div>
                      {IsShowallQrcodeDetails === true ? (
                        <button
                          onClick={async () => {
                            await ShowAllSuperAdminScanCountryDetails();
                            togglesetsuperadminqrscanstt();
                            setselectcountrywisescan("scan");
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      ) : (
                        <button
                          onClick={async () => {
                            await SuperAdminScanCountryDetails(
                              selectQrcodeStartDate,
                              selectQrcodrEndDate
                            );
                            togglesetsuperadminqrscanstt();
                            setselectcountrywisescan("scan");
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                  <div class="widget widget-stats bg-purple mb-7px">
                    <div class="stats-icon stats-icon-lg">
                      <i class="fa fa-qrcode fa-fw"></i>
                    </div>
                    <div class="stats-content">
                      <div class="stats-title">Saved to STT Wallet</div>
                      <div class="stats-number">
                        {" "}
                        {DashboardScanSttWalletDetails?.totalSTTWallet}
                      </div>

                      {IsShowallQrcodeDetails === true ? (
                        <button
                          onClick={async () => {
                            await ShowAllSuperAdminSavedCountryDetails();
                            togglesetsuperadminqrscanstt();
                            setselectcountrywisescan("sttscan");
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      ) : (
                        <button
                          onClick={async () => {
                            await SuperAdminSavedCountryDetails(
                              selectQrcodeStartDate,
                              selectQrcodrEndDate
                            );
                            togglesetsuperadminqrscanstt();
                            setselectcountrywisescan("sttscan");
                          }}
                          class="btn btn-default btn-xs"
                        >
                          Country wise detail
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>

      {/*=========================================== SuperAdmin Modal =========================================== */}
      <Modal
        isOpen={packagemodal}
        toggle={packagetoggleclose}
        className="modal-size"
      >
        <ModalHeader toggle={packagetoggleclose} className="modalheader ">
          <div className="d-flex align-items-center">
            <h4 className="text-white mb-0">
              Category wise customized user details
            </h4>
            <button className="btn btn-primary btm-sm ml-2">
              Download data
            </button>
            {/* <CSVLink
                        headers={Categorycsvheaders}
                        data={Categorycsvdata}
                        filename={'Category_' + Moment(new Date()).format('DD-MM-Y HH:mm:ss') + '.csv'}
                        className="hidden"
                        ref={CategorycsvRef}
                        target="_blank"
                      /> */}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="sparkline8-list shadow-reset">
            <div className="sparkline8-graph table-responsive">
              {maincountryuserlistshow === false ? (
                <table
                  id="data-table-buttons"
                  className="table table-striped table-bordered table-td-valign-middle text-center"
                >
                  <thead>
                    <tr className="odd gradeA">
                      <th className="text-nowrap">Sr #</th>
                      <th className="text-nowrap">Country</th>
                      <th className="text-nowrap">Package</th>
                      <th className="text-nowrap">Users</th>
                      <th className="text-nowrap">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {packagDetailslist.length > 0 &&
                      packagDetailslist.map((item, i) => (
                        <tr>
                          <td>{item?.sr}</td>
                          <td>
                            {item?.packageCountryName
                              ? item?.packageCountryName
                              : "N/A"}
                          </td>
                          <td>
                            {item?.packageName ? item?.packageName : "N/A"}
                          </td>
                          <td>
                            {item?.totalUser ? item?.totalUser : "0"}
                            <button
                              onClick={(e) => {
                                toggleuserdetail(item);
                              }}
                              type="button"
                              className="btn btn-primary btn-xs ml-3"
                            >
                              Details
                            </button>
                          </td>

                          <td>
                            {item?.totalPriceValue
                              ? item?.totalPriceValue
                              : "0"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <DataTable
                  columns={customizedwisecolumn}
                  data={packagDetailslist}
                  sortIcon={
                    <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                  }
                  pagination
                  customStyles={customStyles}
                  theme="solarized"
                  striped
                />
              )}
            </div>
          </div>
          <div className="text-center">
            {packagDetailslist.length > 0 ? (
              maincountryuserlistshow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setmaincountryuserlistshow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setmaincountryuserlistshow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={customizedUsersdetail}
        toggle={toggleuserdetailclose}
        className="modal-size"
      >
        <ModalHeader toggle={toggleuserdetailclose} className="modalheader ">
          <div className="d-flex align-items-center">
            <h4 className="text-white mb-0">User detail</h4>
            {/* <button className="btn btn-primary btm-sm ml-2">
                        Download data</button> */}

            <button className="btn btn-primary btm-sm ml-2">
              Download data
            </button>
            {/* <CSVLink
                        headers={Subcategorycsvheaders}
                        data={Subcategorycsvdata}
                        filename={'Subcategory_' + Moment(new Date()).format('DD-MM-Y HH:mm:ss') + '.csv'}
                        className="hidden"
                        ref={SubcategorycsvRef}
                        target="_blank"
                      /> */}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="sparkline8-list shadow-reset">
            <div className="sparkline8-graph table-responsive">
              {superadmincountryuserlistshow === false ? (
                <table
                  id="data-table-buttons"
                  className="table table-striped table-bordered table-td-valign-middle text-center"
                >
                  <thead>
                    <tr className="odd gradeA">
                      <th className="text-nowrap">Sr #</th>
                      <th className="text-nowrap">Country</th>
                      <th className="text-nowrap">User Email</th>
                      <th className="text-nowrap">Start date</th>
                      <th className="text-nowrap">End date</th>
                      <th className="text-nowrap">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {countryuserlist.length > 0 &&
                      countryuserlist.slice(0, 5).map((item, i) => (
                        <tr>
                          <td>{item?.sr}</td>
                          <td>{item?.countryName}</td>
                          <td>{item?.userEmail}</td>
                          <td>
                            {item.startDate
                              ? Moment(item?.startDate).format("DD / MM / YYYY")
                              : "N/A"}
                          </td>
                          <td>
                            {item.endDate
                              ? Moment(item?.endDate).format("DD / MM / YYYY")
                              : "N/A"}
                          </td>

                          <td>{item?.price}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <DataTable
                  columns={columnsuserdetails}
                  data={countryuserlist}
                  sortIcon={
                    <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                  }
                  pagination
                  customStyles={customStyles}
                  theme="solarized"
                  striped
                />
              )}
            </div>
          </div>
          <div className="text-center">
            {countryuserlist.length > 0 ? (
              superadmincountryuserlistshow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadmincountryuserlistshow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadmincountryuserlistshow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={superadminqrscanstt}
        toggle={togglesetsuperadminqrscanstt}
        className="modal-size"
      >
        <ModalHeader
          toggle={togglesetsuperadminqrscanstt}
          className="modalheader "
        >
          <div className="d-flex align-items-center">
            <h4 className="text-white mb-0">Country wise detail</h4>
            <button
              className="btn btn-primary btm-sm ml-2"
              // onClick={(e) => handleActionsubCategory('DOWNLOAD')}
            >
              Download data
            </button>
            {/* <CSVLink
                        headers={Subcategorycsvheaders}
                        data={Subcategorycsvdata}
                        filename={'Subcategory_' + Moment(new Date()).format('DD-MM-Y HH:mm:ss') + '.csv'}
                        className="hidden"
                        ref={SubcategorycsvRef}
                        target="_blank"
                      /> */}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="sparkline8-list shadow-reset">
            <div className="sparkline8-graph table-responsive">
              <>
                {selectcountrywisescan === "qrcode" ? (
                  superadmQrcodeCountryshow === false ? (
                    <table
                      id="data-table-buttons"
                      className="table table-striped table-bordered table-td-valign-middle text-center"
                    >
                      <thead>
                        <tr className="odd gradeA">
                          <th className="text-nowrap">Sr #</th>
                          <th className="text-nowrap">Country</th>
                          <th className="text-nowrap">Qr Codes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DashboardQrocodeCountryDetails.length > 0 &&
                          DashboardQrocodeCountryDetails.slice(0, 5).map(
                            (item, i) => (
                              <tr>
                                <td>{item?.sr}</td>
                                <td>
                                  {item?.qrCodesCountryName
                                    ? item?.qrCodesCountryName
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.totalQrCodes
                                    ? item?.totalQrCodes
                                    : "0"}
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <DataTable
                      columns={columnsuperadmQrcodeCountry}
                      data={DashboardQrocodeCountryDetails}
                      sortIcon={
                        <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                      }
                      pagination
                      customStyles={customStyles}
                      theme="solarized"
                      striped
                    />
                  )
                ) : (
                  <></>
                )}

                {selectcountrywisescan === "scan" ? (
                  superadminqrscansttlistshow == false ? (
                    <table
                      id="data-table-buttons"
                      className="table table-striped table-bordered table-td-valign-middle text-center"
                    >
                      <thead>
                        <tr className="odd gradeA">
                          <th className="text-nowrap">Sr #</th>
                          <th className="text-nowrap">Country</th>
                          <th className="text-nowrap">Scans</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DashboardScanCountryDetails.length > 0 &&
                          DashboardScanCountryDetails.slice(0, 5).map(
                            (item, i) => (
                              <tr>
                                <td>{item?.sr}</td>
                                <td>
                                  {item?.scansCountryName
                                    ? item?.scansCountryName
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.totalScans ? item?.totalScans : "0"}
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <DataTable
                      columns={columnsuperadmScanCountry}
                      data={DashboardScanCountryDetails}
                      sortIcon={
                        <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                      }
                      pagination
                      customStyles={customStyles}
                      theme="solarized"
                      striped
                    />
                  )
                ) : (
                  <></>
                )}
                {selectcountrywisescan === "sttscan" ? (
                  superadminsavedshow === false ? (
                    <table
                      id="data-table-buttons"
                      className="table table-striped table-bordered table-td-valign-middle text-center"
                    >
                      <thead>
                        <tr className="odd gradeA">
                          <th className="text-nowrap">Sr #</th>
                          <th className="text-nowrap">Country</th>
                          <th className="text-nowrap">STT wallet saving</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DashboardSavedCountryDetails.length > 0 &&
                          DashboardSavedCountryDetails.slice(0, 5).map(
                            (item, i) => (
                              <tr>
                                <td>{item?.sr}</td>
                                <td>
                                  {item?.walletCountry
                                    ? item?.walletCountry
                                    : "N/A"}
                                </td>
                                <td>
                                  {item?.totalwallet ? item?.totalwallet : "0"}
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <DataTable
                      columns={columnsuperadmSavedCountry}
                      data={DashboardSavedCountryDetails}
                      sortIcon={
                        <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                      }
                      pagination
                      customStyles={customStyles}
                      theme="solarized"
                      striped
                    />
                  )
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
          <div className="text-center">
            {selectcountrywisescan === "qrcode" &&
            DashboardQrocodeCountryDetails.length > 0 ? (
              superadmQrcodeCountryshow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadmQrcodeCountryshow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadmQrcodeCountryshow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}

            {selectcountrywisescan === "scan" &&
            DashboardScanCountryDetails.length > 0 ? (
              superadminqrscansttlistshow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadminqrscansttlistshow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadminqrscansttlistshow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}
            {selectcountrywisescan === "sttscan" &&
            DashboardSavedCountryDetails.length > 0 ? (
              superadminsavedshow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadminsavedshow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperadminsavedshow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={superCountrywisesalesdetail}
        toggle={togglesuperCountrywisesalesdetailclosed}
        className="modal-size"
      >
        <ModalHeader
          toggle={togglesuperCountrywisesalesdetailclosed}
          className="modalheader "
        >
          <div className="d-flex align-items-center">
            <h4 className="text-white mb-0">Country wise sales detail</h4>
            <button
              className="btn btn-primary btm-sm ml-2"
              // onClick={(e) => handleActionsubCategory('DOWNLOAD')}
            >
              Download data
            </button>
            {/* <CSVLink
                        headers={Subcategorycsvheaders}
                        data={Subcategorycsvdata}
                        filename={'Subcategory_' + Moment(new Date()).format('DD-MM-Y HH:mm:ss') + '.csv'}
                        className="hidden"
                        ref={SubcategorycsvRef}
                        target="_blank"
                      /> */}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="sparkline8-list shadow-reset">
            <div className="sparkline8-graph table-responsive">
              {superCountrywisesalesdetailishow === false ? (
                <table
                  id="data-table-buttons"
                  className="table table-striped table-bordered table-td-valign-middle text-center"
                >
                  <thead>
                    <tr className="odd gradeA">
                      <th className="text-nowrap">Sr #</th>
                      <th className="text-nowrap">Country</th>
                      <th className="text-nowrap">Sale</th>
                    </tr>
                  </thead>
                  <tbody>
                    {superCountrywiselist.length > 0 &&
                      superCountrywiselist.map((item, i) => (
                        <tr>
                          <td>{item?.sr}</td>
                          <td>{item?.countryName}</td>
                          <td>{item?.totalSale}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <DataTable
                  columns={columnsuperCountrywiselist}
                  data={superCountrywiselist}
                  sortIcon={
                    <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                  }
                  pagination
                  customStyles={customStyles}
                  theme="solarized"
                  striped
                />
              )}
            </div>
          </div>
          <div className="text-center">
            {countryuserlist.length > 0 ? (
              superCountrywisesalesdetailishow === false ? (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperCountrywisesalesdetailishow(true);
                  }}
                >
                  See All
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-purple m-5"
                  onClick={(e) => {
                    setsuperCountrywisesalesdetailishow(false);
                  }}
                >
                  Hide
                </button>
              )
            ) : (
              <></>
            )}
          </div>
        </ModalBody>
      </Modal>
      {/*=========================================== SuperAdmin Modal =========================================== */}
    </div>
  );
};
const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "400",
    },
  },
  rows: {
    style: {
      minHeight: "67px", // override the row height
      borderWidth: 1,
      borderColor: "#e4e7ea",
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "600",
    },
  },
  cells: {
    style: {
      fontSize: "15px",
      fontWeight: "400",
    },
  },
};
export default Superdashboard;
